import { useState } from 'react';
import './PatentApplicationsFilter.css';
import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';
import { getPatentApplications } from '../../utilities/api/patentApplications';

const defaultPatentApplicationsFilters = {
    "clientName": "",
    "patentType": "",
    "applicationType": "",
    "applicationStatus": "",
    "filingStatus": "",
    "createdAtStart": "",
    "createdAtEnd": "",
    "updatedAtStart": "",
    "updatedAtEnd": "",
}

const patentTypeOptions = [
    { value: 'utility', label: 'Utility' },
    { value: 'design', label: 'Design' },
]

const applicationTypeOptions = [
    { value: 'provisional', label: 'Provisional' },
    { value: 'nonProvisional', label: 'Non-Provisional' },
    { value: 'PCT', label: 'PCT' },
    { value: 'canadian', label: 'Canadian' },
    { value: 'foreign', label: 'Foreign' },
]

const applicationStatusOptions = [
    { value: 'abandoned', label: 'Abandoned' },
    { value: 'allowed', label: 'Allowed' },
    { value: 'approved', label: 'Approved' },
    { value: 'awaitingExam', label: 'Awaiting Exam' },
    { value: 'cancelled', label: 'Cancelled' },
    { value: 'expired', label: 'Expired' },
    { value: 'filed', label: 'Filed' },
    { value: 'granted', label: 'Granted' },
    { value: 'NOAIssued', label: 'NOA Issued' },
    { value: 'officeActionIssued', label: 'Office Action Issued' },
    { value: 'published', label: 'Published' },
]

export default function PatentApplicationsFilter({ user, updatePatentApplications, isMobile, sortHeader }) {
    const [filter, setFilter] = useState(defaultPatentApplicationsFilters)
    const [loading, setLoading] = useState(false)

    const getApplications = async () => {
        try {
            const allPatentApplications = await getPatentApplications(user)
            return allPatentApplications.sort((a, b) => a[sortHeader] < b[sortHeader] ? 1 : -1)
        } catch (error) {
            console.log(error)
        }
    }

    const resetFilter = async () => {
        setLoading(true)
        // clear content of all input fields
        const form = document.getElementById('patentApplicationsFilter');
        for (let i = 0; i < form.elements.length; i++) {
            if (form.elements[i].type === 'text' || form.elements[i].type === 'date' || form.elements[i].type === 'select-one') {
                form.elements[i].value = '';
            }
        }
        setFilter(defaultPatentApplicationsFilters)
        const freshApplicationsData = await getApplications();
        updatePatentApplications(freshApplicationsData)
        setLoading(false)
    }

    const filterApplications = async () => {
        setLoading(true)
        const freshApplicationsData = await getApplications();
        const cleanedFilter = Object.keys(filter).reduce((acc, key) => {
            if (filter[key]) {
                acc[key] = filter[key];
            }
            return acc;
        }, {});

        const updatedApplicationsList = freshApplicationsData.filter(application => {
            return (
                (cleanedFilter.clientName ? application.clientName.toLowerCase().includes(cleanedFilter.clientName.toLowerCase().trim()) : true) &&
                (cleanedFilter.patentType ? application.patentType === cleanedFilter.patentType : true) &&
                (cleanedFilter.applicationType ? application.applicationType === cleanedFilter.applicationType : true) &&
                (cleanedFilter.applicationStatus ? application.applicationStatus === cleanedFilter.applicationStatus : true) &&
                (cleanedFilter.filingStatus ? application.filingStatus === cleanedFilter.filingStatus : true) &&
                (cleanedFilter.createdAtStart ? new Date(application.createdAt) >= new Date(cleanedFilter.createdAtStart) : true) &&
                (cleanedFilter.createdAtEnd ? new Date(application.createdAt) <= new Date(cleanedFilter.createdAtEnd) : true) &&
                (cleanedFilter.updatedAtStart ? new Date(application.updatedAt) >= new Date(cleanedFilter.updatedAtStart) : true) &&
                (cleanedFilter.updatedAtEnd ? new Date(application.updatedAt) <= new Date(cleanedFilter.updatedAtEnd) : true)
            );
        });

        updatePatentApplications(updatedApplicationsList);
        setLoading(false)
    }

    const handleChange = (evt) => {
        const newFilterData = {
            ...filter,
            [evt.target.name]: evt.target.value
        }
        setFilter(newFilterData)
    }
  return (
    <div className='PatentApplicationsFilter dropdown patentApplicationsFilterDropDown'>
        <button className='patentApplicationsFilterDropDownToggle' id='patentApplicationsFilterDropDownToggle' title='Patent Applications Filter' data-title='Patent Applications Filter' data-bs-toggle="dropdown" data-bs-auto-close='outside' aria-expanded="false">
            <svg width="16" height="20" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.5 6H13.5M1 1H16M6 11H11" stroke="#1B2B41" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            { !isMobile && <span>Filters</span> }
        </button>
        <div className='dropdown-menu patentApplicationsFilterDropDown' aria-labelledby="patentApplicationsFilterDropDownToggle">
            <div className='header'>
                <div className='svgContainer'>
                    <svg width="16" height="20" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.5 6H13.5M1 1H16M6 11H11" stroke="#1B2B41" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
                <span>Filters</span>
            </div>
            <form id='patentApplicationsFilter'>
                <div className='form-group'>
                    <label htmlFor="clientName" className='form-label'>Client Name</label>
                    <input type="text" id="clientName" name='clientName' className='form-control' onChange={handleChange} value={filter.clientName} />
                </div>
                <div className='form-group'>
                    <label htmlFor="patentType" className='form-label'>Patent Type</label>
                    <select id="patentType" name='patentType' className='form-select' onChange={handleChange}>
                        <option value="">Show All</option>
                        { patentTypeOptions.map((option, index) => (
                            <option key={index} value={option.value}>{capitalizeFirstLetter(option.label)}</option>
                        ))}
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor="applicationType" className='form-label'>Application Type</label>
                    <select id="applicationType" name='applicationType' className='form-select' onChange={handleChange}>
                        <option value="">Show All</option>
                        { applicationTypeOptions.map((option, index) => (
                            <option key={index} value={option.value}>{capitalizeFirstLetter(option.label)}</option>
                        ))}
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor="applicationStatus" className='form-label'>Application Status</label>
                    <select id="applicationStatus" name='applicationStatus' className='form-select' onChange={handleChange}>
                        <option value="">Show All</option>
                        { applicationStatusOptions.map((option, index) => (
                            <option key={index} value={option.value}>{capitalizeFirstLetter(option.label)}</option>
                        ))}
                    </select>
                </div>
                <div>Creation Date</div>
                <div className='form-group split'>
                    <div>
                        <label htmlFor="createdAtStart" className='form-label'>Start</label>
                        <input type="date" id="createdAtStart" name='createdAtStart' className='form-control' onChange={handleChange} />
                    </div>
                    <div>
                        <label htmlFor="createdAtEnd" className='form-label'>End</label>
                        <input type="date" id="createdAtEnd" name='createdAtEnd' className='form-control' onChange={handleChange} />
                    </div>
                </div>
                <div>Last Update</div>
                <div className='form-group split'>
                    <div>
                        <label htmlFor="updatedAtStart" className='form-label'>Start</label>
                        <input type="date" id="updatedAtStart" name='updatedAtStart' className='form-control' onChange={handleChange} />
                    </div>
                    <div>
                        <label htmlFor="updatedAtEnd" className='form-label'>End</label>
                        <input type="date" id="updatedAtEnd" name='updatedAtEnd' className='form-control' onChange={handleChange} />
                    </div>
                </div>
            </form>
            <div className='buttonContainer'>
                <button className='btn btn-primary' type='button' onClick={filterApplications} form='patentApplicationsFilter' disabled={loading}>Filter</button>
                <button className='btn btn-secondary' type='reset' form='patentApplicationsFilter' onClick={resetFilter} disabled={loading}>Reset</button>
            </div>
        </div>
    </div>
  )
}
